import type { ReactElement } from "react"
import { useTranslation } from "react-i18next"
import { usePageTracking } from "../../../hooks"
import { AnalyticsPageCategory, AnalyticsPageType } from "../../../models"
import { Header3 } from "../../atoms"
import { PageContainer } from "../../molecules"

export function UnauthorizedPage(): ReactElement {
  usePageTracking(AnalyticsPageCategory.Unknown, AnalyticsPageType.Error)
  const { t } = useTranslation("general")

  return (
    <PageContainer id="unauthorized">
      <Header3>{t("noAccessToPage")}</Header3>
    </PageContainer>
  )
}
